<template>
  <v-data-table
    :headers="headers"
    :items="deliveries"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="Delivery-button-new"
          @click="$router.push({
            name: 'shop-EditDelivery'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'shop-EditDelivery',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListDelivery',
  module: 'Shop',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('deliveries', ['deliveries']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('driverId'),
          value: 'driverId',
        },
        {
          text: this.$$t('orderId'),
          value: 'orderId',
        },
        {
          text: this.$$t('status'),
          value: 'status',
        },
        {
          text: this.$$t('notes'),
          value: 'notes',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_deliveries();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('deliveries', ['LOAD_deliveries', 'DELETE_delivery']),
    /** Delete Delivery from the collection
     */
    async remove(delivery) {
      this.isLoading = true;
      await this.DELETE_delivery(delivery.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# Delivery example

'''js
<Delivery />
'''
</docs>
